import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { NavBarBackButton } from '@/design-system';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

export const Maps: React.FC = () => {
  const { search } = useLocation();
  const [markerPosition, setMarkerPosition] = useState(null);
  const [address, setAddress] = useState<string>('');
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: `${process.env.REACT_APP_GOOGLE_API_KEY}`,
    libraries: ['places'],
  });
  const searchParams = new URLSearchParams(search);
  const googleMapsUrl = searchParams.get('url');

  const mapContainerStyle = {
    width: '100%',
    minHeight: '92vh',
  };

  const getCoordinates = async () => {
    try {
      if (googleMapsUrl) {
        const url = new URL(googleMapsUrl);
        const addressParam = url.searchParams.get('q');
        if (addressParam) {
          const response = await fetch(`
            https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
              addressParam
            )}&key=${process.env.REACT_APP_GOOGLE_API_KEY}
          `);
          const data = await response.json();
          if (data.results && data.results.length > 0) {
            const { lat, lng } = data.results[0].geometry.location;
            setAddress(addressParam);
            //@ts-ignore
            setMarkerPosition({ lat, lng });
          }
        }
      }
    } catch (error) {
      console.log('error=>', error);
    }
  };

  useEffect(() => {
    getCoordinates();
  }, []);

  return (
    <>
      <NavBarBackButton trackId="maps_page">Google Maps</NavBarBackButton>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          zoom={12}
          //@ts-ignore
          center={markerPosition}
        >
          {markerPosition && <Marker position={markerPosition} title={address} />}
        </GoogleMap>
      )}
    </>
  );
};
